<template>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">应急作战指挥中事件</div>
      </zj-layout-header>
      <zj-layout-main style="padding-top: 0rem;">
        <div class="zj-search-result-table">
          <label class="labelname">应急中事件共 {{eventLength}} 件</label>
          <el-table :data="tableData" @row-click="rowclick" :show-header="false">
            <el-table-column>
              <template slot-scope="scope">
                <ComponentInfoPanel
                  type="EmergencyIncidentStorage"
                  v-bind:info="convert(scope.$index,scope.row)"
                  :FitEventTypeDic="FitEventTypeDic"
                  :EventLevelDic="EventLevelDic"
                ></ComponentInfoPanel>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </zj-layout-main>
    </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
import ComponentInfoPanel from "./Component-InfoPanel";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZJEmergencyIncidentList",
  controller: "UI",
  action: "EmergencyIncidentList",
  components: {
    ComponentInfoPanel: ComponentInfoPanel
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      tableData: [],
      eventLength: 0,
      FitEventTypeDic: [],
      EventLevelDic: []
    };
  },
  created: function() {
    this.bindDatabase()
    .then(()=>{
      this.search();
    });
    this.logInfo.ActionName = "应急中事件列表查看";
    this.logInfo.LogMessage = "应急中事件列表查看";
    this.logInfo.ModuleName = "应急系统";
    this.logInfo.PageName = "应急中事件列表";
    this.addOperationLog();
  },
  methods: {
    convert(index, row) {
      var result = {
        index: index,
        id: row.EventId,
        executId: row.ExecutId,
        eventName: row.EventName,
        emergencyWhen: row.EmergencyWhen,
        eventDate: row.EventDate,
        contact: row.ReporterName,
        phone: row.ReporterPhone,
        eventType: row.EventType,
        eventLevel: row.EventLevel,
        address: row.EventLocation,
        ConfirmEventType:row.ConfirmEventType,
        ConfirmEventLevel:row.ConfirmEventLevel
      };
      return result;
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    bindDatabase() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        this.config.getUValue("EmergencyService:FitEventType:", ""),
        this.config.getUValue("EmergencyService:EmergencyEventLevel:", "")
      ])
      .then(r => {
        let d;

        //事件类型
        d = r[0];
        for (let i = 0; i < d.JValue.length; i++) {
          let item = d.JValue[i];
          this.FitEventTypeDic[item.ItemKey] = item.Extend1;
        }

        d = r[1];
        for (let i = 0; i < d.JValue.length; i++) {
          let item = d.JValue[i];
          this.EventLevelDic[item.ItemKey] = item.Extend1;
        }
        
        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    },
    search() {
      let searchInfo = {
        Status: 4, //应急中状态
        PageSize: 200,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      this.loadingText = '加载中...';
      new MyApis.EmergencyEventApi()
        .GetEmergencyIncidentList(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r;
          this.eventLength = this.tableData.length;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.zj-search-result-table .labelname{
    padding-top: 0.5rem;
    padding-left: 3rem;
    padding-bottom: 1.5rem;
}
</style>